import { pathJoin } from 'src/reducers/routing/utils'

export const createAreasValueRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') => pathJoin(prefix)(id).chain,
})
